<template>
  <div>
    <div class="modal fade" :class="{ show: show }" :style="{ display: show ? 'block' : 'none' }">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ pageContent.modal_title }}</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <p class="mb-3">{{ pageContent.modal_intro }}</p>
            <ul class="list-group">
              <li class="list-group-item">
                <div class="row align-items-center m-0 p-0">
                  <div class="col-4 text-center">
                    <a href="https://kahoot.com/" target="_blank">
                      <img src="/assets/smart-tools/kahoot.png" alt="Kahoot Logo" class="img-fluid rounded" />
                    </a>
                  </div>
                  <div class="col-8">
                    <a href="https://kahoot.com/files/2021/06/StarterGuide_0621.pdf" target="_blank">
                      {{ pageContent.tool_1_title }}
                    </a>
                    <p class="text-smart-tools">{{ pageContent.tool_1_desc }}</p>
                  </div>
                </div>

              </li>


              <li class="list-group-item">
                <div class="row align-items-center m-0 p-0">
                  <div class="col-4 text-center">
                    <a href="https://quizizz.com/" target="_blank">
                      <img src="/assets/smart-tools/quizizz.png" alt="Quizizz Logo" class="img-fluid rounded" />
                    </a>
                  </div>
                  <div class="col-8">
                    <a href="https://static1.squarespace.com/static/5e280cf36a6c054956c3b3a1/t/62564174ede29c6e57eb61eb/1649820049588/Quizizz+%28Teacher%27s+Guide%29.pdf"
                      target="_blank">
                      {{ pageContent.tool_2_title }}
                    </a>
                    <p class="text-smart-tools">{{ pageContent.tool_2_desc }}</p>
                  </div>
                </div>


              </li>
              <li class="list-group-item">
                <div class="row align-items-center m-0 p-0">
                  <div class="col-4 text-center">
                    <a href="https://canva.com/" target="_blank">
                      <img src="/assets/smart-tools/canva.webp" alt="Canva Logo" class="img-fluid rounded" />
                    </a>
                  </div>
                  <div class="col-8">
                    <a href="https://www.canva.com/learn/canva-for-education/" target="_blank">
                      {{ pageContent.tool_3_title }}
                    </a>
                    <p class="text-smart-tools">{{ pageContent.tool_3_desc }}</p>
                  </div>
                </div>



              </li>
              <li class="list-group-item">
                <div class="row align-items-center m-0 p-0">
                  <div class="col-4 text-center">
                    <a href="https://zoom.com/" target="_blank">
                      <img src="/assets/smart-tools/zoom.webp" alt="Zoom Logo" class="img-fluid rounded" />
                    </a>
                  </div>
                  <div class="col-8">
                    <a href="https://explore.zoom.us/docs/doc/Education%20Guide%20-%20Getting%20Started%20on%20Zoom.pdf "
                      target="_blank">
                      {{ pageContent.tool_4_title }}
                    </a>
                    <p>{{ pageContent.tool_4_desc }}</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              {{ pageContent.modal_close_button }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    pageContent: {
      type: Object,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}

.text-smart-tools {
  font-size: 12px;
}
</style>